import { useState } from "react";
import Cookies from "js-cookie";
import {
  displaySuccess,
  displayError,
} from "stores/flashmessages/flashMiddleware";
import { useDispatch } from "react-redux";

const useFetch = () => {
  // eslint-disable-next-line no-undef
  const API_URL = process.env.REACT_APP_API_URL;
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const abortController = new AbortController();

  const get = async (query) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(API_URL + query, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
        signal: abortController.signal,
      });
      const responseData = await response.json();

      if (!response.ok) {
        throw responseData;
      }
      setData(responseData);
      setIsLoading(false);
      return responseData;
    } catch (error) {
      const errMessage = error.error ? error.error : "An error has occured";
      setError(errMessage);
      console.log(errMessage);
    }
  };

  const post = async (query, userData, callback, okFlash, failedFlash) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(API_URL + query, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
        signal: abortController.signal,
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw responseData;
      }
      setIsLoading(false);
      if (callback) {
        callback();
      }
      if (response.ok && okFlash) {
        dispatch(okFlash);
      } else if (!response.ok && failedFlash) {
        dispatch(failedFlash);
      }
      return responseData;
    } catch (error) {
      const errMessage = error.errors ? error.errors : "An error has occurred.";
      setError(errMessage);
      console.log(errMessage);
    }
  };

  const postAvatar = async (query, userData) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(API_URL + query, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
        body: userData,
        signal: abortController.signal,
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw responseData;
      }
      setData(responseData);
      setIsLoading(false);
      return responseData;
    } catch (error) {
      const errMessage = error.errors ? error.errors : "An error has occurred.";
      setError(errMessage);
      console.log(errMessage);
    }
  };

  const put = async (query, userData, callback, okFlash, failedFlash) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(API_URL + query, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
        signal: abortController.signal,
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw responseData;
      }
      setData(responseData);
      setIsLoading(false);
      if (callback) {
        callback();
      }
      if (response.ok && okFlash) {
        dispatch(okFlash);
      } else if (!response.ok && failedFlash) {
        dispatch(failedFlash);
      }
      return responseData;
    } catch (error) {
      const errMessage = error.errors ? error.errors : "An error has occurred.";
      setError(errMessage);
      console.log(errMessage);
    }
  };

  const patch = async (query, userData, okFlash, failedFlash) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(API_URL + query, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
        signal: abortController.signal,
      });

      const responseData = await response.json();

      if (response.ok && okFlash) {
        dispatch(okFlash);
        setData(responseData);
        setIsLoading(false);
        return responseData;
      } else if (!response.ok && failedFlash) {
        dispatch(failedFlash);
      }
    } catch (error) {
      const errMessage = error.errors ? error.errors : "An error has occurred.";
      setError(errMessage);
      console.log(errMessage);
    }
  };

  const destroy = (query, callback, dispatchValidation) => {
    setIsLoading(true);
    setError(null);

    fetch(API_URL + query, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${Cookies.get("token")}`,
        "Content-Type": "application/json",
      },
      signal: abortController.signal,
    }).then((response) => {
      setIsLoading(false);
      if (response.ok) {
        if (dispatchValidation !== false) {
          dispatch(displaySuccess("All good!"));
        }
        if (callback) {
          callback();
        }
      } else {
        dispatch(displayError("Oops, something bad happened! "));
        setError("Une erreur est survenue");
      }
    });
  };

  const cancelRequest = () => {
    abortController.abort();
  };

  return {
    data,
    error,
    isLoading,
    get,
    post,
    postAvatar,
    put,
    patch,
    destroy,
    cancelRequest,
  };
};
export default useFetch;
